// extracted by mini-css-extract-plugin
export default {"root":"b1rPgq68Zz","handle":"FrFrLKZeaD","root_disabled":"z6YOKpJp2b","text":"oeBuRI0vB8","text_ellipsed":"ThnAJKu6e6"};